<template>
  <v-btn
    icon
    :variant="variant"
    :color="color"
    :density="density"
    :size="size"
    :disabled="disabled"
    :loading="loading"
    :aria-label="tooltip"
    @click="$emit('click', $event)"
    v-bind="$attrs"
  >
    <!-- Slot for custom content (e.g., when using badge), otherwise show icon -->
    <slot v-if="$slots.default" />
    <v-icon v-else :size="iconSize">{{ iconName }}</v-icon>
    <v-tooltip activator="parent" location="bottom">
      {{ tooltip }}
    </v-tooltip>
  </v-btn>
</template>

<script setup>
defineOptions({
  inheritAttrs: false
})

defineProps({
  iconName: {
    type: String,
    required: true
  },
  iconSize: {
    type: [String, Number],
    default: undefined
  },
  tooltip: {
    type: String,
    required: true
  },
  variant: {
    type: String,
    default: 'text'
  },
  color: {
    type: String,
    default: undefined
  },
  density: {
    type: String,
    default: undefined
  },
  size: {
    type: String,
    default: undefined
  },
  disabled: {
    type: Boolean,
    default: false
  },
  loading: {
    type: Boolean,
    default: false
  }
})

defineEmits(['click'])
</script>
